export const AMENITY_CODES = [
    '24-hour-check-in',
    '24-hour-front-desk',
    '24-hour-security',
    'access-to-healthcare-professionals',
    'accessible-parking',
    'adults-only',
    'aerobics',
    'air-conditioning',
    'airport-shuttle',
    'all-inclusive-meals',
    'all-rooms-disinfected-daily',
    'archery',
    'atm-on-site',
    'audio-visual-equipment-rental',
    'auditory-guidance',
    'baby-safety-gates',
    'badminton',
    'baggage-storage',
    'banquet-rooms',
    'bar',
    'bar-crawls',
    'bathhouse',
    'bathroom-emergency-pull-cord',
    'bbq-facilities',
    'beach',
    'beach-area-private',
    'beach-chairs-loungers',
    'beach-umbrellas',
    'beachfront',
    'beauty-services',
    'bicycle-rental',
    'bike-tours',
    'billiards-pool-table',
    'bingo',
    'board-games-puzzles',
    'boating',
    'body-thermometer',
    'books-dvds-music-for-kids',
    'bottled-water',
    'bowling',
    'breakfast-buffet',
    'breakfast-complimentary',
    'breakfast-continental',
    'breakfast-in-the-room',
    'breakfast-takeaway-containers',
    'business-center',
    'buzzer-wireless-intercom',
    'canoeing',
    'car-for-hire',
    'car-rental',
    'carbon-monoxide-detector',
    'carbon-monoxide-sources',
    'cashless-payment-accepted',
    'casino',
    'cctv-in-common-areas',
    'cctv-outside-property',
    'chapel',
    'child-friendly-buffet',
    'childcare-services',
    'childrens-club',
    'childrens-meals',
    'childrens-tv-channels',
    'chocolate-cookies',
    'cleaning-chemicals-used-are-effective-against-covid',
    'coffee-shop',
    'common-areas-disinfected-daily',
    'common-stationery-removed',
    'concierge',
    'contactless-check-in',
    'contactless-check-out',
    'cooking-class',
    'couples-only',
    'cycling',
    'daily-housekeeping',
    'darts',
    'delivered-food-covered-securely',
    'designated-smoking-area',
    'diving',
    'doorman',
    'dry-cleaning',
    'electric-vehicle-charging-station',
    'elevator',
    'entertainment-staff',
    'ethernet-internet-connection',
    'ethernet-internet-connection-charges-apply',
    'ethernet-internet-connection-complimentary',
    'evening-entertainment',
    'express-check-in',
    'express-check-out',
    'exterior-corridor',
    'face-masks-available-for-guests',
    'face-masks-on-staff',
    'facilities-for-disabled-guests',
    'family-rooms',
    'fax-services',
    'fire-extinguishers',
    'fireplace',
    'first-aid-kit',
    'fishing',
    'fitness-center',
    'food-can-be-delivered-for-in-room-dining',
    'food-delivery',
    'foot-bath',
    'foreign-currency-exchange',
    'fruit',
    'game-room',
    'garden',
    'gift-shop',
    'golf-course-on-site',
    'golf-course-within-35-km-2-mi',
    'grocery-deliveries',
    'guest-accommodation-cleaning-can-be-cancelled',
    'guest-accommodations-disinfected-between-stays',
    'guest-accommodations-sealed-after-cleaning',
    'guest-health-checks',
    'guest-parking',
    'hair-beauty-salon',
    'hand-sanitizer-provided',
    'happy-hour',
    'heating',
    'hiking',
    'honeymoon-bridal-suite',
    'horseback-riding',
    'hot-spring-bath',
    'hot-tub',
    'hygiene-certification',
    'hypoallergenic-rooms',
    'indoor-play-area',
    'infirmary',
    'internet',
    'invoices',
    'ironing-service',
    'karaoke',
    'key-card-or-motion-controlled-electricity',
    'laundry-service',
    'library',
    'linens-towels-laundry-washed-per-local-authority-guidelines',
    'live-music-performance',
    'live-sports-events-broadcast',
    'local-safety-protocols-followed',
    'locker-rooms',
    'lockers',
    'lounge',
    'low-bathroom-sink',
    'luggage-valet-service',
    'massage',
    'massage-chair',
    'meeting-rooms',
    'miniature-golf',
    'minimarket-convenience-store',
    'mobile-app-for-room-service',
    'movie-nights',
    'newspapers',
    'nightclub-dj',
    'no-children-allowed',
    'non-smoking-rooms',
    'open-air-bath',
    'outdoor-fireplace',
    'outdoor-furniture',
    'outdoor-play-equipment',
    'personal-trainer',
    'pet-friendly',
    'photocopying-services',
    'physical-distancing-in-dining-areas',
    'physical-distancing-rules',
    'picnic-area',
    'playground',
    'pool-beach-towels',
    'portable-wi-fi-device-rental',
    'postal-service',
    'prepared-lunches',
    'printer',
    'private-check-in',
    'private-check-out',
    'property-cleaned-by-professional-cleaning-companies',
    'property-has-wheelchair-access',
    'public-transit-tickets',
    'racquetball-squash',
    'raised-toilet',
    'refillable-water-stations',
    'restaurant',
    'restaurant-halal',
    'restaurant-kosher',
    'room-service',
    'room-service-24-hours',
    'safe-deposit-boxes-at-front-desk',
    'safety-deposit-box',
    'sanitized-tableware',
    'sauna',
    'screens-between-staff-guests-where-needed',
    'security-alarm',
    'self-service-laundry',
    'shared-kitchen',
    'shared-lounge-tv-area',
    'shoeshine',
    'shops-on-site',
    'shrine',
    'shuttle-service',
    'single-use-plastics-removed',
    'ski-equipment-rental',
    'ski-school',
    'skiing',
    'smoke-alarms',
    'smoke-free-property',
    'snack-bar',
    'snorkeling',
    'solarium',
    'soundproof-rooms',
    'spa',
    'special-diet-meals-on-request',
    'stand-up-comedy',
    'steam-room',
    'sterilizing-equipment',
    'strollers',
    'suit-trouser-press',
    'sun-deck',
    'surfing-lessons',
    'swimming-pool',
    'table-tennis-ping-pong',
    'taxi-service',
    'temperature-check-for-guests-and-staff',
    'temporary-art-galleries',
    'tennis-court',
    'terrace',
    'theme-park',
    'themed-dinners',
    'thermometers-for-guests',
    'ticketing-service',
    'toilet-with-grab-rails',
    'tour-assistance',
    'tours',
    'towels-changed-upon-request',
    'turkish-steam-bath',
    'valet-parking',
    'vending-machine-drinks',
    'vending-machine-snacks',
    'vending-machines-contents-unspecified',
    'vip-room-facilities',
    'visual-aids-braille',
    'visual-aids-tactile-signs',
    'walking-tours',
    'water-park',
    'water-sports-equipment-rental',
    'water-sports-motorized',
    'water-sports-non-motorized',
    'waterslide',
    'welcome-drink',
    'wifi-charges-apply',
    'wifi-complimentary',
    'windsurfing',
    'wine-champagne',
    'wireless-internet',
    'yoga',
    '110-120-volt-circuits',
    '220-240-volt-circuits',
    'accessible-bathroom',
    'accessible-bedroom',
    'accessible-by-elevator',
    'air-purifiers',
    'alarm-clock',
    'alfresco-dining',
    'alfresco-shower',
    'away-from-elevator',
    'baby-amenities-upon-request',
    'baby-bath',
    'baby-monitor-listening-device',
    'balcony',
    'barbecue',
    'bathrobes',
    'bathroom',
    'bathtub',
    'beach-towels',
    'bidet',
    'blackout-curtains',
    'body-lotion',
    'books',
    'breakfast-included',
    'cable-television',
    'ceiling-fan',
    'changing-table',
    'child-size-bathrobe',
    'child-size-slippers',
    'childcare',
    'childrens-bike',
    'childrens-books-toys',
    'childrens-dinnerware',
    'childrens-high-chair',
    'city-view',
    'cleaning-included',
    'cleaning-optional',
    'cleaning-products',
    'close-to-elevator',
    'coffee-maker',
    'communal-pool',
    'complimentary-bottled-water',
    'complimentary-mini-bar',
    'conditioner',
    'connecting-rooms-available',
    'cooking-basics',
    'crib-upon-request',
    'daily-newspaper',
    'desk',
    'dining-area',
    'dishwasher',
    'dryer',
    'eco-friendly-amenities',
    'electric-vehicle-charger',
    'electric-kettle',
    'electrical-current-voltage',
    'espresso-machine-with-pods',
    'exercise-equipment',
    'extra-pillows-and-blankets',
    'fire-alarm-with-light',
    'fire-alarms',
    'fire-pit',
    'flat-screen-television',
    'floor-ground',
    'floor-high',
    'floor-low',
    'floor-top',
    'free-laundry-service',
    'free-welcome-drink',
    'freezer',
    'full-kitchen',
    'full-size-mirror',
    'gaming-console',
    'gaming-console-charges-apply',
    'gaming-console-complimentary',
    'garage',
    'garden-or-backyard',
    'garden-view',
    'glassware-and-cups',
    'golf-course-access',
    'grab-rails-in-shower',
    'grab-rails-in-toilet',
    'hairdryer',
    'hand-sanitiser',
    'heated-floors',
    'heated-pool',
    'hot-water',
    'humidifier',
    'in-room-tablet',
    'indoor-pool',
    'inner-courtyard-view',
    'ipod-docking-station',
    'iron',
    'iron-board',
    'key-card-energy-saving-functionality',
    'kitchen',
    'kitchenette',
    'kitchenware',
    'lake-access',
    'lake-view',
    'landmark-view',
    'laptop-safe-box',
    'limited-access-floor',
    'linens',
    'lunch-included',
    'microwave',
    'mini-bar',
    'mini-fridge',
    'motion-detecting-energy-saving-functionality',
    'mountain-view',
    'non-smoking',
    'ocean-view',
    'outdoor-hot-tub',
    'outdoor-kitchen',
    'outdoor-sauna',
    'outdoor-seating',
    'outlet-covers',
    'oven',
    'parking',
    'parking-charges-apply',
    'parking-complimentary',
    'patio',
    'pay-per-view-channels',
    'plates-and-bowls',
    'play-area',
    'playroom',
    'pool',
    'pool-towels',
    'pool-view',
    'portable-fans',
    'portable-wifi',
    'power-outlets-close-to-bed',
    'private-bathroom',
    'private-beach-access',
    'private-entrance',
    'private-pool',
    'radio',
    'recycling-options',
    'refrigerator',
    'river-view',
    'roll-in-shower',
    'safe-box',
    'safety-chain-andor-latch-on-door',
    'satellite-television',
    'sea-view',
    'seating-area',
    'security-system',
    'self-closing-door',
    'separate-toilet-area',
    'sewing-kit',
    'shampoo',
    'shared-bathroom',
    'shoeshine-kit',
    'shower',
    'shower-chair',
    'shower-gel',
    'silverware-utensils',
    'single-use-plastic-amenities-replaced',
    'slippers',
    'smart-tv',
    'smoke-detectors',
    'smoking-allowed',
    'smoking-policy',
    'sofa-bed',
    'soundproofing',
    'spa-services',
    'stair-gates',
    'step-free-access',
    'step-stool',
    'stove',
    'streaming-service',
    'street-parking',
    'street-view',
    'table-corner-guards',
    'television',
    'toaster',
    'toilet-paper',
    'toiletries',
    'toothbrush',
    'towel-and-linen-reuse-program',
    'towels',
    'transfer-shower',
    'ttyt-dd-compatibility',
    'turndown-service',
    'video-games',
    'video-on-demand',
    'wake-up-calls',
    'walk-in-shower',
    'wardrobe-or-closet',
    'washer',
    'water-conservation-system',
    'weight-scale',
    'window-guards',
    'window-opens',
    'wood-stove',
];
